var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"meme bg-blueGray-50"},[_c('input-form',{staticClass:"meme-editor"}),_c('output-table')],1),_c('modal-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }